import styled, {
  createGlobalStyle,
  css,
  keyframes,
  ThemeProvider,
} from 'styled-components/macro'
import theme, { IThemeInterface } from './theme'
// import './fontLoader'
import './toastify'
import '../assets/fonts/gfonts.css'
import './reactDates'
import DateStyles from './reactDates'

const BrowserStyles = createGlobalStyle`
   html { 
     overscroll-behavior: contain;
     -webkit-text-size-adjust: 100%;
   }
      
   body{
     margin: 0;                  
     padding: 0;
     overscroll-behavior: contain;
     -webkit-overflow-scrolling: touch;
     overflow-scrolling: touch;
     max-height: 568px;
     max-height: var(--full);
     background-color: #ebedef;
     width: 100%;
     -webkit-tap-highlight-color: transparent;
     position: relative;
     overflow-x: hidden;
   }
`

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.15;
  }

  a,
  a:hover,
  a:focus {
    text-decoration: none;
    outline: none;
  }
  
  input::-ms-clear, input::-ms-reveal {
    display: none;
  }
  
  input::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  
  .bbn__box__number{
    background-color: white;
    padding: 0px 5px 0px 0px;
    white-space: nowrap;
  }
  .bbn__box__number--green:before{
    width: 8px;
    height: 8px;
    margin: 5px;
    border-radius: 50%;
    display: inline-flex;
    content: " ";
    background-color: #00a541;
  }
  .bbn__box__number--blue:before{
    width: 8px;
    height: 8px;
    margin: 5px;
    border-radius: 50%;
    display: inline-flex;
    content: " ";
    background-color: #1f3975;
  }
  
  .status-box{
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    background-color: #ebedef;
  }
  
  .btn-update-href {
    color: #00a541;
    cursor: pointer;
  }
  
  .hideScroll{
    scrollbar-width: none;
  }
  
  .hideScroll::-webkit-scrollbar {
    display: none;
  }


  //nasty solution with full of hope that we will never use ReactModal ever again 
  .ReactModal__Content {
    @media (max-width: ${(props: ITheme) =>
      props.theme && props.theme.breakpoints.mobile}) {
      top: 45px !important;
    }
  }
  
  #BBWidgetTooltip .MuiTooltip-tooltip {
    background-color: #fff;
    box-shadow: 0px 0px 4px rgba(0,0,0,0.25);
    color: black;
    font-size: 11px;
    position: relative;
    word-break: break-all;
  }

`

export default styled as any
export {
  css,
  keyframes,
  ThemeProvider,
  theme,
  GlobalStyles,
  BrowserStyles,
  DateStyles,
}

export interface ITheme {
  theme: IThemeInterface
}
